import constants from "src/constants";

function calcSize(
  size:
    | "0"
    | "xt"
    | "tn"
    | "xs"
    | "sm"
    | "nm"
    | "xn"
    | "md"
    | "xm"
    | "lg"
    | "xl"
    | "hg"
    | "xh"
    | "xx"
) {
  return (function () {
    switch (size) {
      case `0`:
        return "0";
      case `xt`:
        return constants.Size.xt;
      case `tn`:
        return constants.Size.tn;
      case `xs`:
        return constants.Size.xs;
      case `sm`:
        return constants.Size.sm;
      case `nm`:
        return constants.Size.nm;
      case `xn`:
        return constants.Size.xn;
      case `md`:
        return constants.Size.md;
      case `xm`:
        return constants.Size.xm;
      case `lg`:
        return constants.Size.lg;
      case `xl`:
        return constants.Size.xl;
      case `hg`:
        return constants.Size.hg;
      case `xh`:
        return constants.Size.xh;
      case `xx`:
        return constants.Size.xx;
    }
  })();
}

export default calcSize;
